
import { database, ref, push, get, set } from "../../FirebaseConfig";

/**
 * Vérifie si un utilisateur existe dans la base de données et l'insère si nécessaire
 * @param {string} id - L'identifiant Telegram de l'utilisateur
 * @param {string} nom - Le nom d'utilisateur Telegram
 * @returns {Promise<{success: boolean, userData: object|null, isNewUser: boolean, error: string|null}>}
 */
export const checkAndInsertData = async (id, nom) => {
  // Résultat par défaut
  const result = {
    success: false,
    userData: null,
    isNewUser: false,
    error: null
  };

  // Validation des paramètres
  if (!id) {
    result.error = "ID utilisateur manquant";
    return result;
  }

  try {
    // Crée une référence à l'emplacement de l'identifiant spécifique
    const dataRef = ref(database, `vendeur/${id}`);
    const timestampNow = Date.now();
    
    // Vérifier si les données existent déjà
    const snapshot = await get(dataRef);
    
    if (snapshot.exists()) {
      // L'utilisateur existe déjà
      result.success = true;
      result.userData = snapshot.val();
      result.isNewUser = false;
      console.log(`Utilisateur existant récupéré: ${id}`);
    } else {
      // Données à insérer pour un nouvel utilisateur
      const data = {
        balanceGratuit: 0,
        balancePayant: 0,
        id_recto: "recto-id",
        id_verso: "verso-id",
        card_in_hand: true,
        kyc_done: true,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        verification: true,
        plan: false,
        type_plan: "",
        nom: nom || "Utilisateur",
        deja: false
      };

      // Insérer les données
      await set(dataRef, data);
      
      // Vérifier que l'insertion a bien fonctionné
      const newSnapshot = await get(dataRef);
      if (newSnapshot.exists()) {
        result.success = true;
        result.userData = newSnapshot.val();
        result.isNewUser = true;
        console.log(`Nouvel utilisateur créé: ${id}`);
      } else {
        throw new Error("Échec de l'insertion des données");
      }
    }
  } catch (error) {
    result.error = error.message || "Erreur inconnue";
    console.error("Erreur lors de la vérification ou de l'insertion des données:", error);
  }

  return result;
};
